
/* injects from baggage-loader */

import {combineReducers} from 'redux'
import traffic from './traffic'
import landings from './landings'
import funnels from './funnels'
import orders from './orders'
import incommings from './incomming'

export default combineReducers({
  traffic,
  landings,
  funnels,
  orders,
  incommings
})



// WEBPACK FOOTER //
// ./client/redux/modules/insights/index.js